"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../Button/utils");
var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));
var _createStyles = require("../styles/createStyles");
var _responsiveProps = require("../utilities/responsiveProps");
const _excluded = ["children", "classes", "className", "color", "component", "disabled", "size", "type", "variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const {
    styles,
    spacing
  } = theme.busbud;
  const sizeCssDefinitions = {
    size: {
      /* Styles applied to the root element if `size="xs"`. */
      xs: {
        borderRadius: styles.rounding.sm,
        padding: spacing(0.5)
      },
      /* Styles applied to the root element if `size="sm"`. */
      sm: {
        borderRadius: styles.rounding.md,
        padding: spacing(0.5)
      },
      /* Styles applied to the root element if `size="md"`. */
      md: {
        borderRadius: styles.rounding.md,
        padding: spacing(1)
      },
      /* Styles applied to the root element if `size="lg"`. */
      lg: {
        borderRadius: styles.rounding.md,
        padding: spacing(1)
      },
      /* Styles applied to the root element if `size="xl"`. */
      xl: {
        borderRadius: styles.rounding.lg,
        padding: spacing(2)
      }
    }
  };
  const sizes = (0, _responsiveProps.generateUnoptimizedResponsiveStyles)(theme, sizeCssDefinitions);
  return _objectSpread(_objectSpread({
    root: {},
    text: {},
    textInherit: {},
    containedInherit: {},
    contained: {},
    disabled: {},
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    }
  }, sizes), (0, _utils.generateVariantStyles)(theme));
});
/**
 * **❗️ DEPRECATED**: Use the new `ButtonIcon` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/forms-buttonicon--docs):
 *
 * ```tsx
 * import { ButtonIcon } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/forms-iconbutton)
 *
 * @deprecated
 */
const IconButton = /*#__PURE__*/_react.default.forwardRef(function IconButton(props, ref) {
  const {
      children,
      classes: classesOverrides,
      className,
      color = 'primary',
      component = 'button',
      disabled = false,
      size = 'sm',
      type = 'button',
      variant = 'contained'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: cx(classes.root, classes[variant], ...(0, _utils.getSizeClassname)(size, classes), {
      [classes[(0, _utils.getVariantColorClassKey)(variant, color)]]: color !== 'inherit',
      [classes.disabled]: disabled,
      [classes.colorInherit]: color === 'inherit'
    }, className),
    component: component,
    disabled: disabled,
    ref: ref,
    type: type
  }, other), children);
});
var _default = exports.default = IconButton;